<div [formGroup]="group" [attr.class]="styleForm" [class.hasError]="hasError">
    <label *ngIf="label" [attr.for]="controlName">{{ label }}</label>
    <div [class.has-icon]="icon" class="field">
        <i *ngIf="icon" [attr.class]="icon"></i>
        <p-autoCompleteFb [suggestions]="suggestions"
                          [formControlName]="controlName"
                          [placeholder]="placeholder"
                          field="code"
                          [itemLabel]="itemLabel"
                          [required]="required"
                          [strict]="strict"
                          [focusMe]="focusEmit"
                          (onBlur)="onBlur($event)"
                          delay="10"
                          #fieldElement
        ></p-autoCompleteFb>                <!---->

        <div class="form-error-flux"
             *ngIf="hasError && group.controls[controlName].errors && group.controls[controlName].errors.required">
            {{Yii.t('wui-shared-js', 'champ requis')}}
        </div>
    </div>
</div>
